import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";

// The service worker (registerType: "autoUpdate") already activates a new
// version immediately in the background via skipWaiting/clientsClaim, but
// an already-open tab has no way to know its in-memory JS is now stale —
// without this, users only ever get a new deploy after manually clearing
// site data. Reloading once when a new worker takes control is the
// standard fix and needs no visible prompt.
if ("serviceWorker" in navigator) {
  let reloadedForUpdate = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadedForUpdate) return;
    reloadedForUpdate = true;
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter basename="/app">
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
